import React, { forwardRef } from "react";
import { Input } from "./Input";
import { EyeIcon, EyeOffIcon } from "../../../assets/ui/icons";

/* Password field with a visibility toggle. */
export const PasswordInput = forwardRef(function PasswordInput(
  { visible = false, onToggleVisibility = () => {}, ...rest },
  ref
) {
  return (
    <Input
    ref={ref}
    type={visible ? "text" : "password"}
    trailing={
      <button
        type="button"
        onClick={onToggleVisibility}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 w-9 h-9 rounded-lg flex items-center justify-center text-[var(--muted)] hover:text-[var(--ink-2)] hover:bg-[var(--slate-2)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--orange)]"
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    }
      {...rest}
    />
  );
});

export default PasswordInput;
